import React, { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

const inputCls = "w-full bg-[#1B1B28] border hairline px-3 py-2 text-sm focus:outline-none focus:border-cyan-400/60";

export default function ForcePasswordChange() {
  const { user, setSession } = useAuth();
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const valid = f.next.length >= 10 && f.next === f.confirm && f.current;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      setSession({ token: localStorage.getItem("cds_token"), user: { ...user, must_change_password: false } });
      toast.success("Password updated — welcome to your portal");
    } catch (err) { toast.error(err?.response?.data?.detail || "Could not change password"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open>
      <DialogContent data-testid="force-password-dialog" className="bg-[#1B1B28] border-white/10 text-zinc-100 sm:max-w-[440px] rounded-none [&>button]:hidden" onPointerDownOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="font-display font-extrabold tracking-tight flex items-center gap-2"><KeyRound size={16} className="text-cyan-300" /> Choose your password</DialogTitle>
          <DialogDescription className="text-zinc-500 text-xs">You signed in with a temporary password. Set your own (10+ characters) to continue.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <input data-testid="pw-current" type="password" required className={inputCls} placeholder="Temporary password" value={f.current} onChange={(e) => setF({ ...f, current: e.target.value })} />
          <input data-testid="pw-new" type="password" required minLength={10} className={inputCls} placeholder="New password (min 10 chars)" value={f.next} onChange={(e) => setF({ ...f, next: e.target.value })} />
          <input data-testid="pw-confirm" type="password" required className={inputCls} placeholder="Confirm new password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} />
          {f.confirm && f.next !== f.confirm && <div className="text-[11px] text-red-400">Passwords do not match</div>}
          <button data-testid="pw-submit" type="submit" disabled={!valid || busy}
            className="w-full bg-cyan-400 text-[#15151F] hover:bg-cyan-300 px-3 py-2.5 text-[11px] font-mono uppercase tracking-widest font-bold disabled:opacity-50 transition-colors duration-150">
            {busy ? "SAVING…" : "SET PASSWORD"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
